<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="all"
      :footer-props="{
        itemsPerPageText: 'Filas por página',
        itemsPerPageOptions: [10,15,30,50,100]
      }"
      :loading="loading"
      :options.sync="optionsLocal"
      :server-items-length="itemsLength"
      disable-sort
      @click:row="onSelect"
    >
      <template v-slot:group.header="{ group, items }">
        <td :colspan="headers.length">
          <strong>{{ new Date(group).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) }}</strong> ({{ items.length }} ítems)
        </td>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Tickets</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="onRefresh" color="primary" fab small>
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.fecha="{ item }">
        <div v-if="item.fecha">
          {{ item.fecha | moment('DD/MM/YYYY') }}
        </div>
      </template>
      <template v-slot:item.cantidad="{ item }">
        <div v-if="item.coeficiente === 1">
          {{ item.cantidad | formatToThreeDecimals }}
        </div>
        <div v-if="item.coeficiente > 1">
          {{ (item.cantidad / item.coeficiente) }}
        </div>
      </template>
      <template v-slot:item.producto_id="{ item }">
        <div v-if="item.producto_id">
          {{ productoNombre(item.producto_id) }}
        </div>
      </template>
      <template v-slot:no-data>
        <v-alert color="warning" icon="mdi-alert">
          No hay información de tickets para mostrar.
        </v-alert>
      </template>
      <template v-slot:pageText="props">
        Filas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ProductosMixin from '@/mixins/Productos'
export default {
  name: 'TicketsDatatableComponent',
  mixins: [ProductosMixin],
  data () {
    return {
      //
    }
  },
  computed: {
    ...mapGetters('Tickets', ['edited', 'all', 'headers', 'loading', 'itemsLength', 'options']),
    optionsLocal: {
      get () {
        return this.options
      },
      set (value) {
        this.setOptions(value)
        this.onFetch()
      }
    },
  },
  methods: {
    ...mapActions('Tickets', ['onFetch']),
    ...mapMutations('Tickets', ['setEdited', 'setSelected', 'setOptions']),
    onSelect (item) {
      /* Se cargan los datos en la variable Seleccionado para comparar */
      const aux = {
        ...this.edited,
        id: item.id,
        transaccion_tipo: item.transaccion_tipo,
        transaccion_detalle: item.transaccion_detalle,
        fecha: item.fecha,
        cantidad: item.cantidad,
        coeficiente: item.coeficiente,
        importe: item.importe,
        cuenta_id: item.cuenta_id,
        created_at: item.created_at,
        updated_at: item.updated_at
      }
      this.setEdited(aux)
      this.setSelected(aux)
      this.$emit('update:selected', true)
    },
    onRefresh(event) {
      event.preventDefault()
      this.onFetch()
    },
  }
}
</script>
